import FaqItem from "./FaqItem";

const defaultFaqs = [
  {
    q: "What is Eveness?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "How does AI styling works?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Do I need an account to use Eveness?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "What Features does Eveness offer?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Can Eveness help with wardrobe planning?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Is my data and privacy secure?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Is Eveness free to use?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "How does AI styling works?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Can Eveness help with wardrobe planning?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
  {
    q: "Do I need an account to use Eveness?",
    a: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero numquam quibusdam natus nisi repellat reprehenderit laborum mollitia eum architecto, ipsam eaque obcaecati velit nemo ullam assumenda delectus, doloribus maxime adipisci error laudantium consequuntur. Aliquam eaque incidunt dolore rem amet nisi, nam distinctio quidem reprehenderit consequatur inventore, aliquid similique sint velit.",
  },
];

const FaqSection = ({ faqs }) => {
  const faqItems = Array.isArray(faqs) && faqs.length > 0 ? faqs : defaultFaqs;

  return (
    <div className="mt-6 bg-[#F7F5F2] rounded-[12px] p-6 md:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <div className="font-normal text-[28px] md:text-[36px] md:leading-[56px] tracking-[-1.12px] align-middle text-black max-w-[400px]">
            Frequently asked questions
          </div>
        </div>

        <div className="bg-transparent">
          {faqItems.map((f, i) => (
            <FaqItem key={i} q={f.q} a={f.a} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;